import * as types from "./actionTypes";

const initialState = {
    bills: [],
    isBillsLoading: true,
    endReached: false,
    offset: 0,
    limit: 50,
    refund: {
        sum: 0,
        transactionId: 0,
        vkId: 0,
    },
    paySum: '',
    todaySum: 0,
    todayRefund: 0,
    lastSum: [],
};

export const bills = (state = initialState, action) => {

    switch (action.type) {

        case types.START_LOADING:
            return {
                ...state,
                isBillsLoading: true,
            };

        case types.ADD_BILLS:
            let addBills = {...state.bills};

            action.bills
                .forEach(bill => {
                    const id = 'id-' + bill.id;
                    if (addBills[id] === undefined) addBills[id] = bill;
                });

            return {
                ...state,
                bills: {...addBills},
                offset: state.offset + state.limit,
                isBillsLoading: false,
            };

        case types.SET_BILLS:
            let setBills = {};
            let lastSums = [];

            if (action.bills.length > 0)
                action.bills
                    .forEach(bill => {
                        const id = 'id-' + bill.id;
                        setBills[id] = bill;
                        lastSums.push(bill.sum);
                    });

            return {
                ...state,
                bills: {...setBills},
                offset: state.limit,
                isBillsLoading: false,
                lastSum: lastSums,
                endReached: false,
            };

        case types.SET_END_REACHED:
            return {
                ...state,
                endReached: true,
            };

        case types.SET_REFUND:
            return {
                ...state,
                refund: {
                    sum: action.sum,
                    transactionId: action.transactionId,
                    vkId: action.vkId,
                },
            };

        case types.SET_REFUND_SUM:
            return {
                ...state,
                refund: {
                    ...state.refund,
                    sum: action.sum,
                },
            };

        case types.SET_BILL_REFUND:
            let newBills = {...state.bills};
            const id = 'id-' + action.transactionId;
            if (newBills[id] !== undefined)
                newBills[id] = {
                    ...newBills[id],
                    status: 2,
                    refund_sum: +newBills[id].refund_sum + +action.sum,
                    date_refund: action.date,
                    all_refunds: newBills[id].all_refunds + action.sum + ';' + action.date + '|'
            };
            return {
                ...state,
                bills: {...newBills},
            };

        case types.SET_PAY_SUM:
            return {
                ...state,
                paySum: action.paySum,
            };

        case types.ADD_BILL_AT_START:
            let newBill = {};
            newBill['id-' + action.bill.id] = action.bill;
            return {
                ...state,
                bills: { ...newBill, ...state.bills },
                lastSum: [action.bill.sum, ...state.lastSum],
            };

        case types.SET_TODAY_SUM:
            return {
                ...state,
                todaySum: action.todaySum,
                todayRefund: action.todayRefund,
            };

        default:
            return state;

    }

};


// WEBPACK FOOTER //
// ./src/js/store/bills/reducers.js